export default "__VITE_ASSET__e3dfebbe__"